<div class="dashboard">
  @if (loading) {
    <div class="loader-container">
      <mds-loader></mds-loader>
    </div>
  }
  @if (!loading) {
    <div class="apps">
      <app-common-apps
        class="common-apps-container"
        [appDetails]="appDetails"
        [appsData]="categories$ | async"
        [appItems]="null"
        (onAppDataClick)="onAppData($event)"
        [isShowSeeMore]="true"
      ></app-common-apps>
      <app-common-apps
        class="common-apps-container"
        [appDetails]="actionDetails"
        [appsData]="actionsData"
        [appItems]="null"
        (onAppDataClick)="doAction($event)"
        [isShowSeeMore]="false"
        [hasDashBorder]="true"
      ></app-common-apps>
    </div>
    <div class="apps pinned-items-margin">
      <app-common-apps
        class="common-apps-container"
        [appDetails]="favAppDetails"
        [appItems]="favoriteApps"
        (onAppDataClick)="openAppModal($event)"
        (headerEvent)="configureFavApps()"
        [isShowSeeMore]="false"
        [loading]="loaderForFavApps"
        [extraData]="{list: apps$ | async, selectedList: favoriteApps}"
      ></app-common-apps>
    </div>
    <div class="apps bottom-container">
      <div class="box">
        <app-common-apps
          class="common-apps-container report-apps"
          [appDetails]="reporting"
          [appsData]="reportApps"
          [appItems]="null"
          (onAppDataClick)="onReportAppsClicked($event)"
          [isShowSeeMore]="false"
        ></app-common-apps>
        @if (loaderForFavTemplate) {
          <mds-loader></mds-loader>
        }
        @if (favoriteTemplates && favoriteTemplates.length != 0) {
          <div>
            <app-header-container class="header-bottom-margin" [appDetails]="pinnedTemplates"></app-header-container>
            <div class="items" data-testid="dashboard-pinned-templates">
              @for (template of favoriteTemplates; track template) {
                <a
                  class="template-box item no-border no-padding no-background"
                  [attr.data-testid]="'dashboard-template-card-' + template.rid"
                  [attr.aria-label]="template.title"
                  role="button"
                  (click)="$event.stopPropagation()"
                  [routerLink]="getReportLink(true, template).path"
                  [queryParams]="getReportLink(true, template).queryParams"
                  style="text-decoration: none"
                  >
                  <mds-template-card
                    [title]="template.title"
                    [description]="template.description"
                    [icon]="template.icon"
                    [tag]="template.tag"
                  ></mds-template-card>
                </a>
              }
            </div>
          </div>
        }
      </div>
      <div class="box header-bottom-margin">
        <app-header-container class="header-bottom-margin" [appDetails]="newsFeeds"></app-header-container>
        @if (loaderForNewsFeed) {
          <mds-loader></mds-loader>
        }
        @if (newsFeedsList && newsFeedsList.length != 0) {
          <div class="news-feed-container">
            <div class="activity-subject">
              <mds-button-toggle
                class="activity-subject-option"
                [checkedButton]="selectedNewsFeedSubject"
                [options]="newsFeedSubjectOptions"
                [multiple]="false"
                [name]=""
                (change)="onNewsFeedSubjectChange($event)"
              ></mds-button-toggle>
              <mds-dropdown-menu
                [text]="'Show'"
                [multiple]="true"
                [checkbox]="true"
                [showBadge]="true"
                [options]="newsFeedTypes"
                [selectedValue]="selectedNewsFeedTypes"
                [badgeOptions]="badgeOptions"
                (selectedValueChange)="onFeedTypeSelection($event)"
              ></mds-dropdown-menu>
            </div>
            @for (news of visibleItems; track news) {
              <div class="news-feed-item-container">
                <div class="news-feed-item">
                  @if (news.image?.startsWith('https')) {
                    <img class="item-image" [src]="news.image" alt="icon" (error)="onImageError($event, news)" />
                  } @else {
                    <img class="item-image" alt="" [src]="getImagePath(news)" />
                  }
                  <div class="notification-content">
                    @switch (news.feed_type) {
                      @case (NewsFeedType.TEAM_MEMBER_NEWS) {
                        <div>
                          @for (user of news.users; track user; let i = $index; let last = $last) {
                            <a
                              [href]="user.url | newUiRoute: true"
                              target="_blank"
                              tabindex="0"
                              [attr.aria-label]="user.name + ' ' + news.msg"
                              >
                              <span class="link-tag">{{ user.name }}</span>
                            </a>
                            @if (news.users.length > 2 && i < news.users.length - 2) {
                              ,
                            }
                            @if (i === news.users.length - 2) {
                              and
                            }
                          }
                          {{ news.msg }}
                        </div>
                      }
                      @case (NewsFeedType.TEAM_MEMBERS) {
                        <div>
                          @if (news.users.length == 1) {
                            <p>
                              <a tabindex="0" attr.aria-label="{{ news.users.name }} has joined your team">
                                <span class="link-tag">{{ news.users.name }}</span>
                              </a>
                              has joined your team
                            </p>
                          }
                        </div>
                      }
                      @case (NewsFeedType.PRODUCT_ANALYSIS) {
                        <div>
                          <a
                            [href]="news.product.url | newUiRoute: true"
                            target="_blank"
                            tabindex="0"
                            attr.aria-label="news {{ news.product.name }} has been analyzed"
                            >
                            <span class="link-tag">
                              {{
                              news.product.name.length < 40
                              ? news.product.name + ' product'
                              : (news.product.name | slice: 0 : 40) + '...'
                              }}
                            </span>
                          </a>
                          has been analyzed
                        </div>
                      }
                      @case (NewsFeedType.REPORT_NEWS) {
                        <div>
                          <a
                            class="link-tag"
                            attr.aria-label="{{ news.importlink[0].report_name }}"
                            [href]="news.importlink[0].url | newUiRoute: true"
                            tabindex="0"
                            >
                            <span>{{ news.importlink[0].report_name ? news.importlink[0].report_name : ' ? ' }}</span>
                          </a>
                          {{ news.msg }} {{ news.importlink[0].product[0].name }}
                        </div>
                      }
                      @case (NewsFeedType.SHARING_NEWS) {
                        <div>
                          <a
                            class="link-tag"
                            attr.aria-label="{{ news.product[0].name }}"
                            [href]="news.product[0].url | newUiRoute: true"
                            tabindex="0"
                            >
                            {{ news.product[0].name }}
                          </a>
                          {{ news?.type?.toLowerCase() == 'product' ? 'product' : '' }}
                          has been shared with you
                        </div>
                      }
                      @case (NewsFeedType.IMPORT_COMPONENT) {
                        <div>
                          <a
                            class="link-tag"
                            attr.aria-label="{{ news.product.name }} {{ news.msg }}"
                            [href]="openLinkProductName(news.product.url) | newUiRoute: true"
                            tabindex="0"
                            >
                            <span>{{ news.product.name }}</span>
                          </a>
                          {{ news.msg }}
                        </div>
                      }
                    }
                    @if (
                      news.feed_type == NewsFeedType.TEAM_MEMBERS || news.feed_type == NewsFeedType.TEAM_MEMBER_NEWS) {
                      <div class="meta">
                        {{ news.time }}
                      </div>
                    } @else {
                      <div class="meta">{{ news.time }} By {{ news.users | firstUserName }}</div>
                    }
                  </div>
                </div>
                @if (
                  news.feed_type != NewsFeedType.TEAM_MEMBER_NEWS ||
                  (news.feed_type === NewsFeedType.TEAM_MEMBER_NEWS && news.users.length === 1)
                  ) {
                  <mds-button
                    class="news-feed-action"
                    [icon]="getNewsFeedActionIcon(news.feed_type)"
                    [isIconLeft]="true"
                    [isIconRight]="true"
                    [isLeftRightIconSame]="false"
                    [iconRight]="icons.ARROW_FORWARD_LIGHT"
                    [iconPathColors]="['#8A9DA8']"
                    (click)="newsFeedAction(news)"
                    [type]="'tertiary'"
                    >
                    {{ getNewsFeedActionName(news.feed_type) }}
                  </mds-button>
                }
              </div>
            }
            <!-- Show More / Show Less toggle -->
            <div ngClass="button-container">
              @if (shouldShowToggle) {
                <mds-button class="button-container" [type]="'tertiary'" (click)="toggleShow()">
                  {{ showAllFeeds ? 'Show Less' : 'Show ' + (filteredNewsFeedsList?.length - 6) + ' More' }}
                </mds-button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
